export const paymentContentStyle = {
	wrapper: {
		maxWidth: '372px',
		width: '100%',
		margin: '0 auto',
	},

	buttons: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
		margin: '40px 0 32px',

		'& button': {
			height: '44px',
		},
	},

	buttonPaypal: {
		backgroundColor: 'var(--background-paypal)',

		'&:hover': {
			backgroundColor: 'var(--background-paypal-hover)',
		},

		'&:active': {
			backgroundColor: 'var(--background-paypal-active)',
		},
	},

	buttonStripe: {
		backgroundColor: 'var(--background-stripe)',

		'&:hover': {
			backgroundColor: 'var(--background-stripe-hover)',
		},

		'&:active': {
			backgroundColor: 'var(--background-stripe-active)',
		},
	},

	buttonSquare: {
		backgroundColor: 'var(--background-square)',

		'&:hover': {
			backgroundColor: 'var(--background-square-hover)',
		},

		'&:active': {
			backgroundColor: 'var(--background-square-active)',
		},
	},

	buttonHelp: {
		display: 'flex',
		margin: '0 auto 40px',
	},

	modal: {
		'.MuiPaper-root': {
			maxWidth: '770px',
			padding: '48px 100px',
			width: '100%',
			margin: '0',
		},

		'& .MuiTypography-h6': {
			marginBottom: '32px',
		},
	},
};
